import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    selected: { type: Array, default: [] },
    placeholder: { type: String, default: "Type to add filter..." },
    fieldName: String
  };
  static targets = ["select"];

  connect() {
    this.initializeTomSelect();
  }

  disconnect() {
    this.destroyTomSelect();
  }

  initializeTomSelect() {
    if (!this.element) return;

    this.select = new TomSelect(this.selectTarget, {
      plugins: {
        remove_button: {
          label: '<i class="far fa-times-circle" aria-hidden="true"></i>',
          title: 'Remove',
        },
      },
      valueField: 'value',
      labelField: 'value',
      searchField: 'value',
      create: true, // Allow creating arbitrary text values
      persist: false, // Don't persist created items
      placeholder: this.placeholderValue,
      items: this.selectedValue,
      hideSelected: true, // Don't show selected items as options
      openOnFocus: false, // Don't open dropdown on focus
      onItemAdd: () => {
        this.select.setTextboxValue('');
        this.select.focus(); // Keep focus so user can continue adding filters
      },
      render: {
        option_create: function(data, escape) {
          // Don't show "Add..." option if the text is already selected
          if (this.items.includes(data.input)) {
            return null;
          }
          return '<div class="create">Enter <strong>' + escape(data.input) + '</strong>...</div>';
        },
        no_results: null // Don't show "No results found" message
      }
      // No load function - completely static, no backend queries
      // No preload - nothing to load
    });
  }

  destroyTomSelect() {
    if (this.select) {
      this.select.destroy();
    }
  }
}
